import {
  getDietaryIngredients,
  useCustomerDietaryRestrictions,
} from '@hungryroot/dietary-restrictions';
import { usePairing } from '@hungryroot/rest';

export const usePairingDietaryIngredients = (
  id: number,
  options?: {
    enabled: boolean;
    inventory_date?: string;
    origin?: number;
  }
) => {
  const {
    data: dietaryRestrictionsData,
    isLoading: isDietaryRestrictionsDataLoading,
  } = useCustomerDietaryRestrictions();
  const { data, isLoading: isPairingLoading } = usePairing(
    {
      id,
      inventory_date: options?.inventory_date,
      origin: options?.origin,
    },
    options
  );

  const isLoading = isDietaryRestrictionsDataLoading || isPairingLoading;

  if (!data || !dietaryRestrictionsData || isLoading) {
    return {
      data: [],
      isLoading,
    };
  }

  return {
    data: getDietaryIngredients(
      data?.tags,
      dietaryRestrictionsData?.dietary_restrictions
    ),
    isLoading,
  };
};
